<template>
  <v-radio-group v-model="selectedType" hide-details mandatory reaquired class="announcement-type" @change="handleSelection">
    <v-layout row wrap class="announcement-type__main">
      <v-flex xs12 sm6 md5 pb-2>
        <v-radio :value="createChapterStudioConstant.RECORD_TYPE.IMAGE"
                 :color="createChapterStudioConstant.RADIO_COLOR" class="announcement-type__image--radio">
          <template v-slot:label>
            <v-layout column class="full-width">
              <div class="announcement-type__form-title pb-1">{{createChapterStudioConstant.FORM_FIELD.TYPE_IMAGE}}</div>
              <img src="../../assets/image-announcement-bg.png" class="announcement-type__image" alt="image-type">
            </v-layout>
          </template>
        </v-radio>
      </v-flex>
      <v-flex xs12 sm6 md7 pb-2>
        <v-layout column justify-space-between class="full-height">
          <v-flex>
            <v-radio :value="createChapterStudioConstant.RECORD_TYPE.WARNING"
                     :color="createChapterStudioConstant.RADIO_COLOR"
                     class="mb-3 announcement-type__general--radio"
                     >
              <template v-slot:label>
                <v-layout column class="full-width">
                  <v-flex class="announcement-type__form-title pb-1">{{createChapterStudioConstant.FORM_FIELD.TYPE_WARNING}}</v-flex>
                  <v-flex><announcement-type-alert-card type="warning"></announcement-type-alert-card></v-flex>
                </v-layout>
              </template>
            </v-radio>
          </v-flex>
          <v-flex>
            <v-radio :value="createChapterStudioConstant.RECORD_TYPE.GENERAL"
                     :color="createChapterStudioConstant.RADIO_COLOR"
                     class="full-height announcement-type__general--radio">
              <template v-slot:label>
                <v-layout column class="full-width">
                  <v-flex class="announcement-type__form-title pb-1">{{createChapterStudioConstant.FORM_FIELD.TYPE_GENERAL}}</v-flex>
                  <v-flex><announcement-type-alert-card type="general"></announcement-type-alert-card></v-flex>
                </v-layout>
              </template>
            </v-radio>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-radio-group>
</template>

<script>
import { createChapterStudioConstant } from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import AnnouncementTypeAlertCard from "@/components/ChapterStudioPageManage/AnnouncementTypeAlertCard.vue";
import CreateAnnouncementImageUploader from "@/components/ChapterStudioPageManage/CreateAnnouncementImageUploader.vue";

export default {
  name: 'CreateAnnouncementType',
  components: { CreateAnnouncementImageUploader, AnnouncementTypeAlertCard },
  data() {
    return {
      createChapterStudioConstant,
      selectedType: createChapterStudioConstant.RECORD_TYPE.WARNING,
    };
  },
  props: {
    announcementType: {
      type: String,
      required: true,
    },
  },
  async created() {
    this.selectedType = `${this.announcementType || createChapterStudioConstant.RECORD_TYPE.WARNING}`;
  },
  methods: {
    handleSelection() {
      this.$emit("selectedType", this.selectedType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.announcement-type {
  width: 100%;
  margin: 0;
  padding: 0;

  &__main {
    flex-direction: column-reverse;

    @include breakpointMin(sm) {
      flex-direction: row;
    }
  }

  &__form-title {
    font-size: 14px;
    font-weight: 400;
    max-width: 410px;
    display: none;
    color: black;

    @include breakpointMin(sm) {
      display: block;
    }
  }

  &__image {
    max-width: 406px;
    height: 195px;
    border-radius: 8px;
    object-fit: cover;

    @include breakpointMin(sm) {
      height: 266px;
    }
  }
}
</style>

<style lang="scss">
@import "../../common/styles/_responsive.scss";

.announcement-type {
  &__image {
    &--radio {
      margin-right: 0;
      margin-top: 8px;

      @include breakpointMin(sm) {
        margin-top: 0;
        padding-right: 20px;
      }

      .v-input--selection-controls__input {
        position: relative;
        top: -70px;

        @include breakpointMin(sm) {
          top: -85px;
        }
      }
    }
  }

  &__general {
    &--radio {
      margin-right: 0;

      .v-input--selection-controls__input {
        position: relative;
        top: -20px;

        @include breakpointMin(sm) {
          top: -10px;
        }
      }
    }
  }

  .v-input {
    &__control {
      width: 100%;
    }
  }

  .v-radio {
    .v-label {
      width: 100%;
    }
  }
}
</style>
